import { render, staticRenderFns } from "./programCreateModal.vue?vue&type=template&id=01934ede&"
import script from "./programCreateModal.vue?vue&type=script&lang=ts&"
export * from "./programCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports